export default {
      id: "description-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#description-usage",
      toString: function () {
        return this.url;
      }
    }